import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal"

const Notfound = ()=> {
    return (
        <div className="flex flex-col items-center relative">
      <div className="flex flex-col relative pb-20 lg:pb-6 px-8 lg:px-4 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />
        <div className="pt-24 lg:pt-0 flex flex-col w-full text-white">
            
            <img src={process.env.PUBLIC_URL + "./notfound.svg"} className="w-full" alt="page not found" />
            <span className="text-xl">Désolé la page que vous demandez est introuvable.</span>
        </div>
      </div>
    </div>
    )
}

export default Notfound;